import React, { useEffect, useState } from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import axios from 'axios';

interface Allname {
  id: number;
  name: string;
}

const Alluser: React.FC = () => {
  const [data, setData] = useState<Allname[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const token = localStorage.getItem("token");

  const fetchData = async (page = 1, perPage = 10) => {
    try {
      const res = await axios.get('http://localhost:8000/api/allnames', {
        params: {
          page,
          per_page: perPage,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      setData(res.data.data);
      setTotalRows(res.data.total);
      setCurrentPage(res.data.current_page);
      // console.log(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [currentPage, perPage]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    fetchData(1, newPerPage);
  };

  const columns: TableColumn<Allname>[] = [
    {
      name: 'S.No',
      cell: (row, index) => <>{(currentPage - 1) * perPage + index + 1}</>,
      width: '80px',
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
  ];

  return (
    <div>
      <h2>Allname List</h2>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationPerPage={perPage}
        highlightOnHover
        responsive
      />
    </div>
  );
};

export default Alluser;
